// Footer.js
import React from 'react';
import "../css/Footer.css" // Assuming you've saved the above CSS in Footer.css

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>InterviewBlogs</h4>
            <p>High-signal interview experiences from real candidates.</p>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: hello@interviewblogs.com</p>
          </div>
          <div className="footer-section">
            <h4>Explore</h4>
            <a href="/">Interview feed</a>
            <a href="/signup">Create account</a>
          </div>
        </div>
        
      </div>
    </footer>
  );
}

export default Footer;
